import React from 'react';
import cn from 'classnames';

import type { Availability } from 'src/components/HotelCard/types';
import { useTranslation } from '@lt/localization';

import styles from './hotelCardAvailability.module.css';

type HotelCardAvailabilityProps = {
  availability: Availability;
  isHotelOnly: boolean;
  isCompact?: boolean;
};

const HotelCardAvailability: React.FC<HotelCardAvailabilityProps> = ({
  availability,
  isHotelOnly,
  isCompact = false,
}) => {
  const { flight, hotel } = availability;

  const { t } = useTranslation();

  if (!(flight === 'few') && !(hotel === 'few')) {
    return null;
  }

  return (
    <div
      className={cn(styles.container, {
        [styles.compactContainer]: isCompact,
      })}
    >
      {!isHotelOnly
        ? t('hotelcard.card.fewFlight')
        : t('hotelcard.card.fewHotel')}
    </div>
  );
};

export default HotelCardAvailability;
